module.exports = __webpack_public_path__ + "img/checkmark-outline.svg";